var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"videoPlayer",staticClass:"hub-video__container",class:_vm.mobileScreen? 'smallScreen' : 'desktopScreen'},[_c('video',{directives:[{name:"lazy-load",rawName:"v-lazy-load"}],attrs:{"playsinline":"","loop":"","muted":"","autoplay":"","type":"video/mp4","data-src":this.currentVideo},domProps:{"muted":true}})])
}
var staticRenderFns = []

export { render, staticRenderFns }